import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy } from "@angular/core";
import {NbJSThemeVariable, NbThemeService} from '@nebular/theme';
import {Order} from '@libs/api-models';
import * as moment from 'moment/moment';


@Component({
  selector: 'ngx-echarts-line',
  template: `
    <div echarts [options]="options" class="echart"></div>
  `,
})
export class EchartsLineComponent implements AfterViewInit, OnDestroy, OnChanges {
  private colors: NbJSThemeVariable | undefined;
  private echarts: NbJSThemeVariable | undefined;
  options: any = {};
  themeSubscription: any;
  @Input() allOrders!: Order[]
  last30Days: string[]= [];
  isViewInitialized = false;

  constructor(private theme: NbThemeService, private cd: ChangeDetectorRef) {
    const firstDay = moment().subtract(30, 'days')
    while (firstDay.isSameOrBefore(moment(), 'day')) {
      this.last30Days.push(firstDay.format('YYYY-MM-DD'))
      firstDay.add(1, 'days')
    }
  }

  ngAfterViewInit() {
    this.themeSubscription = this.theme.getJsTheme().subscribe(config => {
      this.colors = config.variables;
      this.echarts = (config.variables?.['echarts'] as NbJSThemeVariable);
      this.isViewInitialized = true;
      this.setOptions(this.allOrders);
      this.cd.detectChanges()
    });
  }

  ngOnChanges() {
    if (this.isViewInitialized) {
      this.setOptions(this.allOrders);
    }
  }

  ngOnDestroy() {
    this.themeSubscription.unsubscribe();
  }

  private setOptions(orders: Order[]) {
    const orderTotals = this.sortAndCombineTotalByDate(orders.filter(order => order.success));
    if (this.colors && this.echarts) {
      this.options = {
        backgroundColor: this.echarts['bg'],
        color: [this.colors['danger'], this.colors['primary'], this.colors['info']],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}',
        },
        legend: {
          left: 'left',
          data: ['Sales by Day'],
          textStyle: {
            color: this.echarts['textColor'],
          },
        },
        xAxis: [
          {
            type: 'category',
            data: this.last30Days,
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: this.echarts['axisLineColor'],
              },
            },
            axisLabel: {
              textStyle: {
                color: this.echarts['textColor'],
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: this.echarts['axisLineColor'],
              },
            },
            splitLine: {
              lineStyle: {
                color: this.echarts['splitLineColor'],
              },
            },
            axisLabel: {
              textStyle: {
                color: this.echarts['textColor'],
              },
            },
          },
        ],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        series: [
          {
            name: 'Sales by Day',
            type: 'line',
            data: this.last30Days.map(day => (orderTotals[day] || 0) / 100),
          },
        ],
      };
    }
  }

  private sortAndCombineTotalByDate(orders: Order[]) {
    const sortedOrders = orders.sort((a, b) => {
      return moment(a.timestamp).isBefore(b.timestamp) ? -1 : 1;
    });
    const combinedOrders: any = {};
    sortedOrders.forEach(order => {
      const date = moment(order.timestamp).format('YYYY-MM-DD');
      if (combinedOrders[date]) {
        combinedOrders[date] += order.squareOrderTotalCents;
      } else {
        combinedOrders[date] = order.squareOrderTotalCents;
      }
    });
    return combinedOrders;
  }
}
